<template>
  <div class="welfare-details">
    <div class="news-content">
      <div class="main-content">
        <img :src="imgSrc"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WelfareDetail",
  data() {
    return {
      imgSrc: ""
    }
  },
  created() {
    this.imgSrc = this.$route.query.url;
    window.console.log(this.imgSrc);
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}
.welfare-details {
  width: 100%;
  height: 100%;
  margin-top: 78px;
  background-color: #F5F7FA;
  position: relative;
  overflow: hidden;
  text-align: center;
  .news-title{
    width: 1200px;
    margin: 0 auto;
    ::v-deep .el-breadcrumb__inner.is-link{
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
    span{
      display: inline-block;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
  }
  .news-content {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 160px;

    .main-content {
      padding: 68px 48px;
    }
  }
}
</style>